import api from '@/utils/axios';

/** Keep the API error code (e.g. `validation.name_duplicate`) for inline form errors. */
async function postManage(action, payload, fallbackMessage) {
  try {
    const response = await api.post('departments/manage', { action, ...payload });
    if (!response.data?.success) {
      const error = new Error(response.data?.error?.message || fallbackMessage);
      error.code = response.data?.error?.code || null;
      throw error;
    }
    return response.data.data;
  } catch (err) {
    if (err instanceof Error && err.message && !err.error) {
      throw err;
    }
    const error = new Error(
      err?.response?.data?.error?.message || err?.message || fallbackMessage
    );
    error.code = err?.response?.data?.error?.code || err?.code || null;
    throw error;
  }
}

export const fetchDepartmentsList = async ({
  active = 'all'
} = {}) => {
  const response = await api.get(`departments?active=${encodeURIComponent(active)}`);
  if (!response.data?.success) {
    throw new Error(response.data?.error?.message || 'Failed to fetch departments');
  }
  return Array.isArray(response.data.data) ? response.data.data : [];
};

export const createDepartment = (payload) =>
  postManage('create', payload, 'Failed to create department');

export const updateDepartment = (payload) =>
  postManage('update', payload, 'Failed to update department');

export const updateDepartmentStatus = ({ department_id, is_active }) =>
  postManage(
    'update',
    { department_id, is_active: is_active ? 1 : 0 },
    'Failed to update department status'
  );

export const deleteDepartment = ({ department_id }) =>
  postManage('delete', { department_id }, 'Failed to delete department');

export const fetchDepartmentEditorOptions = async ({ departmentId = null } = {}) => {
  const params = departmentId != null && Number(departmentId) > 0
    ? `?department_id=${encodeURIComponent(String(departmentId))}`
    : '';
  const response = await api.get(`departments/editor-options${params}`);
  if (!response.data?.success) {
    throw new Error(response.data?.error?.message || 'Failed to fetch department editor options');
  }
  return response.data.data || {
    reporting_executives: [],
    head_candidates: [],
    auto_head: null,
  };
};
